"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelvenere": {
    "eaf59b6a": [{
      "hkey": "41bd72c9",
      "slug": "castelvenere",
      "name": "Castelvenere",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-petrara": [{
      "hkey": "41bd72c9",
      "slug": "castelvenere",
      "name": "Castelvenere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e4f7506": [{
      "hkey": "41bd72c9",
      "slug": "castelvenere",
      "name": "Castelvenere",
      "primary": true,
      "skipSearch": false
    }],
    "foresta": [{
      "hkey": "41bd72c9",
      "slug": "castelvenere",
      "name": "Castelvenere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6757081": [{
      "hkey": "41bd72c9",
      "slug": "castelvenere",
      "name": "Castelvenere",
      "primary": true,
      "skipSearch": false
    }],
    "tore": [{
      "hkey": "41bd72c9",
      "slug": "castelvenere",
      "name": "Castelvenere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;